import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/icon-button/index.js';
import { disableBodyScroll, enableBodyScroll } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import '../country-selector/index.js';
import css_248z from './styles/global-nav.scss.js';
import { handleLangChange, renderLangOptions } from './helpers.js';
import img from '../../../../assets/images/cross-modal-icon.svg.js';

// @ts-ignore
class GlobalNav extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.isInMainNavigation = false;
        this.isConvatecGroup = false;
        this.showLanguageSelector = false;
        this.isWithAlert = false;
        this.modalOpen = false;
        this.modalClosing = false;
        this.focusStartEl = null;
        this.focusEndEl = null;
        this.closeButton = null;
        this.menuItems = [];
        this.closeOnEscape = () => {
            this.addEventListener('keydown', (event) => {
                if (event.key === 'Escape')
                    this.handleModalClose();
            });
        };
        this.onMenubarKeydown = (e) => {
            const target = e.target;
            if (!target || target.getAttribute('role') !== 'menuitem')
                return;
            const currentIndex = this.menuItems.indexOf(target);
            if (currentIndex === -1)
                return;
            const isRtl = this.rtl || isRTL();
            const len = this.menuItems.length;
            const focusItem = (nextIndex) => {
                const prev = this.menuItems[currentIndex];
                const next = this.menuItems[nextIndex];
                prev.setAttribute('tabindex', '-1');
                next.setAttribute('tabindex', '0');
                next.focus();
            };
            switch (e.key) {
                case 'ArrowRight':
                    e.preventDefault();
                    focusItem(isRtl ? (currentIndex - 1 + len) % len : (currentIndex + 1) % len);
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    focusItem(isRtl ? (currentIndex + 1) % len : (currentIndex - 1 + len) % len);
                    break;
                case 'Home':
                    e.preventDefault();
                    focusItem(0);
                    break;
                case 'End':
                    e.preventDefault();
                    focusItem(len - 1);
                    break;
            }
        };
    }
    focusTrap() {
        var _a, _b;
        const modalContainer = this.shadowRoot.querySelector('.modal-container');
        if (!this.focusStartEl) {
            this.focusStartEl = document.createElement('input');
            this.focusStartEl.setAttribute('aria-disabled', 'true');
            this.focusStartEl.setAttribute('aria-hidden', 'true');
            this.focusStartEl.setAttribute('tabindex', '-1');
        }
        (_a = modalContainer === null || modalContainer === void 0 ? void 0 : modalContainer.querySelector('.modal-inner')) === null || _a === void 0 ? void 0 : _a.prepend(this.focusStartEl);
        if (!this.focusEndEl) {
            this.focusEndEl = document.createElement('input');
            this.focusEndEl.setAttribute('aria-disabled', 'true');
            this.focusEndEl.setAttribute('aria-hidden', 'true');
            (_b = modalContainer === null || modalContainer === void 0 ? void 0 : modalContainer.querySelector('.modal-inner')) === null || _b === void 0 ? void 0 : _b.append(this.focusEndEl);
            this.focusEndEl.addEventListener('focus', () => {
                var _a, _b, _c;
                this.closeButton = (_b = (_a = this.renderRoot
                    .querySelector('icon-button')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
                (_c = this.closeButton) === null || _c === void 0 ? void 0 : _c.focus();
            });
        }
        this.focusStartEl.focus();
        this.focusStartEl.blur();
    }
    renderLangDropdown() {
        var _a, _b;
        return ((_b = (_a = this.selectedCountry) === null || _a === void 0 ? void 0 : _a.langOptions) === null || _b === void 0 ? void 0 : _b.length)
            ? $ `<label for="language-select" class="visually-hidden">Select website language</label> <select id="language-select" aria-describedby="language-help" name="language" @change="${(e) => handleLangChange(e)}">${renderLangOptions(this.selectedCountry.langOptions)}</select><div id="language-help" class="visually-hidden">Changing language will reload the page</div>`
            : null;
    }
    handleModalOpen() {
        this.modalOpen = true;
        this.focusTrap();
        this.closeOnEscape();
        disableBodyScroll();
        window.CVTModalTargetElement = this.renderRoot.querySelector('.modal-toggle');
    }
    handleModalClose(setFocus = false) {
        var _a;
        this.modalClosing = true;
        if (setFocus) {
            const countrySelectorBtn = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.modal-toggle');
            countrySelectorBtn === null || countrySelectorBtn === void 0 ? void 0 : countrySelectorBtn.focus();
        }
        setTimeout(() => {
            var _a;
            this.modalClosing = false;
            this.modalOpen = false;
            enableBodyScroll();
            (_a = window.CVTModalTargetElement) === null || _a === void 0 ? void 0 : _a.focus();
        }, 300);
    }
    addUnderlineOnHover() {
        var _a;
        const links = (_a = this.shadowRoot.querySelector('[name="links"]')) === null || _a === void 0 ? void 0 : _a.assignedElements();
        links === null || links === void 0 ? void 0 : links.forEach(link => {
            /* eslint-disable no-return-assign, no-param-reassign */
            link.addEventListener('mouseenter', () => (link.style.textDecoration = 'underline'));
            link.addEventListener('mouseleave', () => (link.style.textDecoration = 'none'));
        });
    }
    initRovingTabIndex() {
        const list = this.renderRoot.querySelector('.nav-links ul[role="menubar"]');
        if (!list)
            return;
        this.menuItems = Array.from(list.querySelectorAll('[role="menuitem"]'));
        this.menuItems.forEach((el, i) => el.setAttribute('tabindex', i === 0 ? '0' : '-1'));
        list.addEventListener('keydown', this.onMenubarKeydown);
    }
    firstUpdated() {
        this.initRovingTabIndex();
        this.addUnderlineOnHover();
    }
    connectedCallback() {
        super.connectedCallback();
        const alertBanner = document.querySelector('alert-banner');
        if (alertBanner) {
            this.isWithAlert = true;
        }
    }
    renderCrownLinks() {
        var _a;
        const links = (_a = this.crownLinks) !== null && _a !== void 0 ? _a : [];
        return links.map(link => $ `<li role="none"><a href="${link.url}" role="menuitem">${link.text}</a></li>`);
    }
    renderCrownMenu() {
        var _a;
        if (!((_a = this.crownLinks) === null || _a === void 0 ? void 0 : _a.length))
            return null;
        return $ `<ul role="menubar">${this.renderCrownLinks()}</ul>`;
    }
    renderLanguageSelector() {
        var _a;
        const hasCountryData = !!((_a = this.selectedCountry) === null || _a === void 0 ? void 0 : _a.title);
        if (this.isConvatecGroup || !hasCountryData)
            return null;
        return $ `<div class="language-selector">${this.showLanguageSelector ? this.renderLangDropdown() : null} ${this.renderCountrySelect()}</div>`;
    }
    renderStockPriceTicker() {
        var _a, _b;
        return this.isConvatecGroup
            ? $ `<div class="global-nav__ticker" aria-hidden="true" role="presentation"><iframe src="${(_a = this.stockPriceTicker) === null || _a === void 0 ? void 0 : _a.url}" title="${(_b = this.stockPriceTicker) === null || _b === void 0 ? void 0 : _b.iframeTitle}" class="stock-ticker" scrolling="no" frameborder="0"></iframe></div>`
            : null;
    }
    renderCountrySelect() {
        var _a, _b;
        return $ `<button class="modal-toggle" type="button" aria-expanded="false" aria-haspopup="dialog" aria-controls="country-modal" aria-describedby="country-help" @click="${this.handleModalOpen}"><span>${(_a = this.selectedCountry) === null || _a === void 0 ? void 0 : _a.title}</span> <img loading="lazy" class="country-icon" src="${(_b = this.selectedCountry) === null || _b === void 0 ? void 0 : _b.img}" alt="" role="presentation"></button><div id="country-help" class="visually-hidden">Press Enter or Space to open country selector</div>`;
    }
    render() {
        const modalClassMap = {
            'modal-container': true,
            open: this.modalOpen,
            rtl: this.rtl,
            closing: this.modalClosing,
        };
        return $ `<nav class="global-nav ${o({
            'in-main-navigation': this.isInMainNavigation,
            rtl: this.rtl || isRTL(),
            'global-nav--group': !!this.isConvatecGroup,
        })}" aria-label="Region and language selector"><div class="global-nav__inner">${this.renderStockPriceTicker()}<div class="global-nav__links"><slot name="account"></slot><nav class="nav-links" aria-label="Secondary navigation links">${this.renderCrownMenu()}</nav>${this.renderLanguageSelector()}</div></div><div class="${o(modalClassMap)}" @click="${this.handleModalClose}" @keydown="${this.handleModalClose}"><div class="modal-inner" @click="${(e) => e.stopPropagation()}" @keydown="${(e) => e.stopPropagation()}"><icon-button class="close-button" .onClick="${() => this.handleModalClose()}" customarialabel="close"><img slot="icon" src="${img}" alt="Close Modal Icon"></icon-button><slot name="modal"></slot></div></div></nav>`;
    }
}
GlobalNav.styles = css_248z;
__decorate([
    e({ type: Boolean })
], GlobalNav.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], GlobalNav.prototype, "isInMainNavigation", void 0);
__decorate([
    e({ type: Object })
], GlobalNav.prototype, "selectedCountry", void 0);
__decorate([
    e({ type: Object })
], GlobalNav.prototype, "stockPriceTicker", void 0);
__decorate([
    e({ type: Boolean })
], GlobalNav.prototype, "isConvatecGroup", void 0);
__decorate([
    e({ type: Object })
], GlobalNav.prototype, "crownLinks", void 0);
__decorate([
    e({ type: Boolean })
], GlobalNav.prototype, "showLanguageSelector", void 0);
__decorate([
    t()
], GlobalNav.prototype, "isWithAlert", void 0);
__decorate([
    t()
], GlobalNav.prototype, "modalOpen", void 0);
__decorate([
    t()
], GlobalNav.prototype, "modalClosing", void 0);
customElements.define('global-nav', GlobalNav);

export { GlobalNav };
